import React, { useState, useEffect } from "react";
import {
  Grid, TableContainer, Table, TableCell, TableRow, List, ListItem, Button
} from "@material-ui/core";
import Avatar from '@material-ui/core/Avatar';
import { Link, useHistory } from "react-router-dom";
import FormHeader from "../../../../Components/FormHeader";
import { TabletView } from "react-device-detect";

import SaveIcon from '@material-ui/icons/Save';
import LocalPrintshopIcon from '@material-ui/icons/LocalPrintshop';
import CancelIcon from '@material-ui/icons/Cancel';


/** Third party dependencies */
import html2canvas from 'html2canvas';


/** Local dependencies & Libraries */
import Services from '../../../../Services';

import { helpers } from '../../../../helpers';

import { Imports } from '../../../../Imports';

import Snackbar from '../../../../Components/Snackbar';
import { DatePicker } from "antd";
import { formatSSN } from "../../../../Components/dummyConstant/DummyConstant";
import { getImageUrl } from "../../../../helpers/getImageUrl";
import { documentSubmit } from "../../../../helpers/api";

var moment = require('moment-timezone');


const {
  hr,
} = Services;

const {
  styles: {
    displayNoneStyles: useStyles
  }
} = Imports;



const BootCardAgreement = () => {


  const classes = useStyles();

  const [isPosting, setPosting] = useState(false);

  const [dateofInjury, setDateofInjury] = useState(new Date())

  const [dateOfRelease, setDateOfRelease] = useState(new Date())

  const [formDate, setFormDate] = useState(new Date())

  const [userData, setUserData] = useState({
    firstName: '',
    middleName: '',
    lastName: '',
    ssn: '',
    address: '',
  })

  useEffect(async () => {

    let userProfile = await JSON.parse(localStorage.user_profile);

    let res = await hr.getAllApplicantsByIDApplicantLogin({ id: userProfile.id })

     
    let data = {
      firstName: res?.employee?.firstName || '',
      middleName: res?.employee?.middleName || '',
      lastName: res?.employee?.lastName || '',
      ssn: res?.employee?.ssn || '',
      address: res?.employee?.address || '',
      hireDate: moment(new Date(res?.employee?.joiningDate)).utc().format("MM-DD-YYYY") || ''
      // address1 : res?.employee?.address1 || '',
    }
     
    setUserData(data)

  }, [])



  const access = localStorage.getItem("access_jwt") || null
  const history = useHistory()

  async function onSubmitButton() {

    let data = {
      id: "id",
      employeeName: userData.firstName,
      socialSecurityName: document.getElementById('socialSecurityName').value,
      hireDate: dateofInjury,
      dataSigned: dateOfRelease,
      signature: document.getElementById('signature').value,
      formDate: formDate,
    }

    documentSubmit(setPosting, data, 8, [], access, history)

  }

  return (
    <Grid container xs={12} className="LiqForms-Container">

      <Grid className={isPosting ? classes.DisplayNone : 'FormsHeader'}>
        <List>
          <ListItem>
            <Grid className="FormMenuLogo"></Grid>
          </ListItem>

          <ListItem>
            <button
              onClick={onSubmitButton}
            // type="submit"
            >
              <SaveIcon />
            </button>
          </ListItem>
          <ListItem>
            <Button onClick={() => window.print()}>
              <LocalPrintshopIcon />
            </Button>
          </ListItem>
          <ListItem>
            <Button onClick={() => window.close()}>
              <CancelIcon />
            </Button>
          </ListItem>
        </List>
      </Grid>

      {/* This is new form  (Change Request) */}

      <TableContainer className="MainTable capture">
        <Table className="SecondMainTable">
          <TableRow>
            <TableCell>
              <Table className="w100">
                <TableRow className="w100 mb10 mt10 row justify-center">
                  {/* <TableCell>
                    <div className="logoImageTGS"></div>
                  </TableCell> */}
                  <div className="logoImageTGS"></div>
                </TableRow>
                <TableRow className="w100">
                  <TableCell className="w100 textCenter font20 bold">
                    Boot Cost Payment Agreement
                  </TableCell>
                </TableRow>
              </Table>
              <Table className="mt10">
                {/* --**-- */}
                <TableRow className="w100 mt10 row">

                  <TableCell className="w50 row pr10">
                    <div style={{ display: 'flex', justifyContent: "center", alignItems: "center" }}><p>Hire Date: </p>{<input disabled value={userData?.hireDate} style={{ marginLeft: "5px", background: "transparent", border: 'none' }} />}</div>
                    {/* <DatePicker
                      onChange={(value) => { setDateofInjury(value) }}

                      value={moment(new Date(userData?.hireDate)).utc().format("MM-DD-YYYY")}
                      id="hireDate"
                      className="datePickerReact"
                      disabled5px
                    /> */}
                    {/* <input type="text" name="textfield" id="textfield" className="w h18 pl8 bn bb" /> */}
                  </TableCell>

                </TableRow>

                <TableRow style={{ height: "10px" }}>

                </TableRow>
                <TableRow className="w100 mt10 row">
                  <TableCell className="w100 row">
                    Employee Name
                    <input required type="text" name="textfield" id="empName" className="w h18 pl8 bn bb input-capitalization"
                      value={`${userData?.firstName + ' ' + userData?.lastName}`}
                      disabled
                    />
                  </TableCell>
                </TableRow>


                <TableRow style={{ height: "10px" }}>

                </TableRow>

                <TableRow className="w100 mt10 row">
                  <TableCell className="w100 row">
                    Social Security #:
                    <input required type="text" value={formatSSN(userData?.ssn)} name="textfield" id="socialSecurityName" className="w h18 pl8 bn bb input-capitalization" disabled
                    />
                  </TableCell>
                </TableRow>



                <TableRow style={{ height: "10px" }}>

                </TableRow>



                <TableRow>
                  If for any reason I am terminated or resign from Trans-Global Solutions, Inc. within six (6) months from the date of my initial hire I agree to pay for any training and for the full cost of my work boots and any other personal protective equipment that Trans-Global Solutions, Inc. (TGS) may purchase for me.

                  I authorize that the full cost of training and any personal protective equipment be deducted from my final paycheck if I am terminated/resign within six (6) months of my initial hire date.

                </TableRow>


                <TableRow style={{ height: "10px" }}>

                </TableRow>


                <TableRow style={{ height: "20px", border: '3px solid Lightblue', padding: '20px' }}>

                  <TableCell className="w50 row pr10">
                    YOUR SIGNATURE:
                    <input required type="text" name="textfield" id="signature" className="w bn bb textCenter signatureClass font-20" />
                  </TableCell>

                </TableRow>



                <TableRow style={{ height: "10px" }}>

                </TableRow>


                {/* {  <TableRow style={{ height: "20px" }}>


                  <TableRow className="w100 mt10 row">
                    <TableCell className="w100 row">
                      Company Representative
                      <input required type="text" name="textfield" id="company" className="w h18 pl8 bn bb input-capitalization"
                      />
                    </TableCell>
                  </TableRow>
                </TableRow>} */}




                <TableRow className="w100 mt10 row">
                  <TableCell className="w4">11.</TableCell>
                  <TableCell className="w100 row">
                    Date Signed:
                    {/* <DatePicker
                      onChange={(value) => { setDateOfRelease(value) }}
                      value={dateOfRelease}
                      id="offerDate"
                      className="datePickerReact"
                    /> */}
                    <DatePicker
                      disabled
                      className="datePickerReact"
                      defaultValue={moment()} format={'MM-DD-YYYY'}
                      id="offerDate"
                      onChange={(value) => { setDateOfRelease(value) }}
                    />

                  </TableCell>
                </TableRow>

              </Table>
              {/* --**-- */}


            </TableCell>
          </TableRow>

        </Table>
      </TableContainer>













      <Snackbar></Snackbar>
    </Grid>
  );
}
export default BootCardAgreement;